import copy from 'copy-to-clipboard';

// 复制文本到剪贴板
function copyToClipboard(text: string) {
  copy(text);
}

export default copyToClipboard;
